import { DateFormat, formatDate, parseDate } from '@chillibean/component-library';

export class Cohort {
  constructor(params = {}) {
    this.createdAt = params.createdAt && parseDate(params.createdAt);
    this.id = params.id;
    this.displayName = params.displayName;
    this.subjects = params.subjects || [];
  }

  shortCohort() {
    return { id: this.id, name: this.displayName };
  }

  listParams({ onClick }) {
    return {
      id: this.id,
      header: this.displayName,
      subHeader: formatDate(this.createdAt, DateFormat.DATE_TIME),
      onClick: () => onClick(this.id),
      locked: false,
    };
  }
}

export default Cohort;
